export default "__VITE_PUBLIC_ASSET__45981af5__"